export default "__VITE_ASSET__CuMAOyZM__"